var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gl-rounded-full gl-border-4 gl-border-solid gl-px-[0.5px]",class:_vm.borderStyle},[_c('gl-icon',{staticClass:"gl-rounded-full gl-fill-neutral-0 gl-p-1",class:_vm.iconStyle,attrs:{"name":_vm.itemStatus.icon,"aria-label":_vm.humanStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }